import React, { useState, useMemo, useEffect } from "react";
import S from "./UserList.styled";
import SearchIcon from "../../assets/icons/SearchIcon";
import usePagination from "../../hooks/usePagination";
import Pagination from "../Pagination/Pagination";
import { useExternalUsers, useTranslation } from "../../hooks";
import UserItem from "./UserItem";
import isSubstring from "../utils";
const UserList = ({ handleNewChat, handleEscapeEvent }) => {
    const users = useExternalUsers();
    const [queryString, setQueryString] = useState("");
    const [usersIds, setUsersIds] = useState(new Set());
    const [groupTitle, setGroupTitle] = useState("");
    const [touched, setTouched] = useState(false);
    const strings = useTranslation();
    const filteredUsers = useMemo(() => {
        return [...users.values()].filter((u) => {
            var _a;
            return isSubstring(u.name, queryString) ||
                isSubstring((_a = u.email) !== null && _a !== void 0 ? _a : "", queryString);
        });
    }, [users, queryString]);
    const { state, goNext, goPrevious, changeItemsPerPage } = usePagination(filteredUsers.length);
    const { currentPage, itemsPerPage, maxItems } = state;
    useEffect(() => {
        if (!touched) {
            const names = usersIds.size > 1
                ? [...usersIds]
                    .splice(0, 2)
                    .map((id) => { var _a; return (_a = users.get(id)) === null || _a === void 0 ? void 0 : _a.name; })
                    .join(", ")
                : "";
            setGroupTitle(names);
        }
    }, [usersIds, touched, users]);
    return (React.createElement(S.Wrapper, { onKeyDown: (e) => {
            if (e.key === "Escape" && handleEscapeEvent) {
                handleEscapeEvent();
            }
        } },
        React.createElement(S.Header, null, "Users"),
        React.createElement(S.SubHeader, null,
            React.createElement(S.ChannelSearchContainer, null,
                React.createElement(S.ChannelSearchInputWrapper, null,
                    React.createElement(S.ChannelSearchInputIcon, null,
                        React.createElement(SearchIcon, { fill: "gray" }),
                        React.createElement(S.ChannelSearchInputText, { type: "search", "aria-label": strings.searchUsers, placeholder: strings.searchUsers, onChange: (e) => {
                                setQueryString(e.target.value);
                            } })))),
            React.createElement(S.CreateChatButton, { type: "button", disabled: usersIds.size < 1 || (usersIds.size > 1 && !groupTitle), onClick: () => {
                    handleNewChat(usersIds, groupTitle);
                } }, "Create Chat")),
        React.createElement(S.InputGroup, null,
            React.createElement(S.Input, { disabled: usersIds.size < 2, type: "text", "aria-label": strings.groupTitle, placeholder: strings.groupTitle, value: groupTitle !== null && groupTitle !== void 0 ? groupTitle : "", onChange: (e) => {
                    setTouched(true);
                    setGroupTitle(e.target.value);
                } })),
        React.createElement(S.UserList, null, filteredUsers
            .slice(currentPage * itemsPerPage - itemsPerPage, currentPage * itemsPerPage)
            .map((user) => (React.createElement("li", { key: user.id },
            React.createElement(UserItem, { user: user, handleToggle: (checked) => {
                    if (checked) {
                        usersIds.add(user.id);
                    }
                    else {
                        usersIds.delete(user.id);
                    }
                    setUsersIds(new Set(usersIds));
                }, selected: usersIds.has(user.id) }))))),
        React.createElement(Pagination, { text: "user(s)", itemsLength: maxItems, currentPage: currentPage, itemsPerPage: itemsPerPage, handleNext: goNext, handlePrevious: goPrevious, handleItemsPerPage: changeItemsPerPage })));
};
export default UserList;
//# sourceMappingURL=UserList.js.map